<script lang="ts">
	import { Select } from 'bits-ui';
	import { lang } from '$lib/lang/copy.svelte';
	import { fly } from 'svelte/transition';

	const languages = [
		{ value: 'en', label: 'English' },
		{ value: 'pt', label: 'Portuguese' }
	] as const;
</script>

<Select.Root type="single" bind:value={lang.current}>
	<Select.Trigger
		class="hover:bg-blue-light border-blue-lighter flex cursor-pointer items-center gap-1 rounded border px-3 py-1.5 text-white transition-opacity"
	>
		<iconify-icon icon="mdi:earth" class="h-4 w-4" noobserver></iconify-icon>
		<span class="subtitle-2">{lang.current.toUpperCase()}</span>
	</Select.Trigger>

	<Select.Content sideOffset={8} class="bg-cream border-gray z-40 rounded border shadow" forceMount>
		{#snippet child({ wrapperProps, props, open })}
			{#if open}
				<div {...wrapperProps}>
					<div {...props} transition:fly={{ y: -10, duration: 200 }}>
						{#each languages as { value, label } (value)}
							{@const selected = lang.current === value}
							<Select.Item
								{value}
								class={[
									'button data-[highlighted]:bg-gray data-[highlighted]:text-blue/80 data-[selected]:text-blue border-gray-dark flex cursor-pointer items-center gap-2 border-b px-3 py-2 last-of-type:border-b-0',
									!selected && 'text-gray-dark'
								]}
							>
								{#if selected}
									<div class="bg-red h-2 w-2 rounded-full"></div>
								{/if}
								{label}
							</Select.Item>
						{/each}
					</div>
				</div>
			{/if}
		{/snippet}
	</Select.Content>
</Select.Root>
